const blogReducer = (state, action) => {
  switch (action.type) {
    // Start fetching all blogs
    case "SET_LOADING":
      return {
        ...state,
        isLoading: true,
        isError: false, // reset error
      };

    // Successfully fetched all blogs
    case "MY_BLOG_DATA":
      return {
        ...state,
        isLoading: false,
        blogs: action.payload,
      };

    // Error fetching blogs
    case "MY_BLOG_ERROR":
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    // Start fetching a single blog
    case "SET_SINGLE_LOADING":
      return {
        ...state,
        isSingleLoading: true,
        isError: false, // reset error
      };

    // Successfully fetched single blog
    case "MY_SINGLE_BLOG_DATA":
      return {
        ...state,
        isSingleLoading: false,
        singleBlog: action.payload,
      };

    // Error fetching single blog
    case "MY_SINGLE_BLOG_ERROR":
      return {
        ...state,
        isSingleLoading: false,
        isError: true,
      };

    default:
      return state;
  }
};

export default blogReducer;
